if (!window.customElements.get("marquee-text")) {
  class MarqueeText extends HTMLElement {
    constructor() {
      super();
      if (window.ResizeObserver) {
        new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
      }
    }

    _calculateDuration(entries) {
      const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5);
      const contentWidth = entries[0].contentRect.width;
      const slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);

      const span = entries[0].target.querySelector("span");
      if (!span) return;

      const duration =
        (scrollingSpeed * slowFactor * span.clientWidth) / contentWidth;

      this.style.setProperty(
        "--marquee-animation-duration",
        `${duration.toFixed(3)}s`
      );
    }
  }

  window.customElements.define("marquee-text", MarqueeText);
}


// height match
  document.addEventListener('DOMContentLoaded', () => {
  function setEqualHeight(selectors) {
    selectors.forEach((selector) => {
      const elements = document.querySelectorAll(selector);
      if (!elements.length) return;

      // reset height
      elements.forEach((el) => {
        el.style.height = 'auto';
      });

      // find tallest
      let maxHeight = Math.max(
        ...Array.from(elements).map((el) => el.offsetHeight)
      );

      // apply tallest
      elements.forEach((el) => {
        el.style.height = maxHeight + 'px';
      });

      // console.log(`Tallest height applied for ${selector}:`, maxHeight);
    });
  }

  // call for each group
  function initEqualHeights() {
     if (window.innerWidth >= 475) {
      setEqualHeight([
        '.product-item__title',
        '.product_form_variant',
        '.product-item__price .product-price',
      ]);
    } 
    else {
      document.querySelectorAll(
        '.product-item__title, .product_form_variant, .product-item__price .product-price'
      ).forEach((el) => {
        el.style.height = 'auto';
      });

      document.querySelectorAll('.product-item').forEach((el) => {
        el.style.height = 'fit-content';
      });
    }
  }

  setTimeout(initEqualHeights, 1000);
  window.addEventListener('resize', initEqualHeights);
});



// price on change
  // document.addEventListener('DOMContentLoaded', function () {
  //   const variantSelects = document.querySelectorAll('.variant-select');

  //   if (!variantSelects.length) return;

  //   variantSelects.forEach((variantSelect) => {
  //     const productWrapper = variantSelect.closest('.product-item, .product-block, .product-card');

  //     if (!productWrapper) return;

  //     const priceContainer = productWrapper.querySelector('.product-price');
  //     const addToCartBtn = productWrapper.querySelector('[data-js-product-add-to-cart]');

  //     if (!priceContainer || !addToCartBtn) return;

  //     function updateUI() {
  //       const selectedOption = variantSelect.options[variantSelect.selectedIndex];
  //       if (!selectedOption) return;

  //       const salePrice = selectedOption.dataset.salePrice || '';
  //       const comparePrice = selectedOption.dataset.comparePrice || '';
  //       const quantity = parseInt(selectedOption.dataset.quantity || '0', 10);

  //       console.log('Selected Variant Price:', salePrice);
  //       if (comparePrice) {
  //         console.log('Compare at Price:', comparePrice);
  //       }
  //       console.log('Quantity Available:', quantity);

  //       let html = `
  //         <span class="product-price--original">
  //           <span class="visually-hidden">Regular price</span>${salePrice}
  //         </span>
  //       `;
  //       if (comparePrice && comparePrice !== salePrice) {
  //         html += `
  //           <del class="product-price--compare">
  //             <span class="visually-hidden">Sale price</span>
  //             <span style="text-decoration: line-through;" class="">${comparePrice}</span>
  //           </del>
  //         `;
  //       }
  //       priceContainer.innerHTML = html;

  //       addToCartBtn.setAttribute('data-id', selectedOption.value);
  //       const btnText = addToCartBtn.querySelector('.button__text') || addToCartBtn;

  //       if (quantity <= 0) {
  //         addToCartBtn.setAttribute('disabled', 'disabled');
  //         btnText.textContent = 'Sold Out';
  //       } else {
  //         addToCartBtn.removeAttribute('disabled');
  //         btnText.textContent = 'Add to cart';
  //       }
  //     }
  //     updateUI();
  //     variantSelect.addEventListener('change', updateUI);
  //   });
  // });
 
  document.addEventListener('DOMContentLoaded', function () {
    const variantSelects = document.querySelectorAll('.variant-select');

    if (!variantSelects.length) return;

    variantSelects.forEach((variantSelect) => {
      const productWrapper = variantSelect.closest('.product-item, .product-block, .product-card');
      if (!productWrapper) return;

      const priceContainer = productWrapper.querySelector('.product-price');

      const quickAddContainer = productWrapper.querySelector('quick-add-to-cart');
      if (!quickAddContainer) return;

      const addToCartBtn = quickAddContainer.querySelector('[data-js-product-add-to-cart]');
      const hiddenIdInput = quickAddContainer.querySelector('input[name="id"]');

      if (!priceContainer || !addToCartBtn || !hiddenIdInput) return;

      function updateUI() {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        if (!selectedOption) return;

        const salePrice = selectedOption.dataset.salePrice || '';
        const comparePrice = selectedOption.dataset.comparePrice || '';
        const quantity = parseInt(selectedOption.dataset.quantity || '0', 10);
        const status = selectedOption.dataset.status;
        const variantId = selectedOption.value;

        let html = `
          <span class="product-price--original">
            <span class="visually-hidden">Regular price</span>${salePrice}
          </span>
        `;
        if (comparePrice && comparePrice !== salePrice) {
          html += `
            <del class="product-price--compare">
              <span class="visually-hidden">Sale price</span>
              <span style="text-decoration: line-through;" class="">${comparePrice}</span>
            </del>
          `;
        }
        priceContainer.innerHTML = html;

        hiddenIdInput.value = variantId;
        addToCartBtn.setAttribute('data-id', variantId);

        const btnText = addToCartBtn.querySelector('.button__text') || addToCartBtn;

        if (quantity <= 0 && status == "on") {
          addToCartBtn.setAttribute('disabled', 'disabled');
          btnText.textContent = 'Sold Out';
        } else {
          addToCartBtn.removeAttribute('disabled');
          btnText.textContent = 'Add to cart';
        }
      }

      updateUI();

      variantSelect.addEventListener('change', updateUI);

      addToCartBtn.addEventListener('click', function () {

        addToCartBtn.classList.add('is-loading');

        if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
          const unsubscribe = FoxTheme.pubsub.subscribe('CART:updated', () => {
            addToCartBtn.classList.remove('is-loading');
            if (typeof unsubscribe === 'function') unsubscribe();
          });
        } else {
          setTimeout(() => {
            addToCartBtn.classList.remove('is-loading');
          }, 1000);
        }
      });
    });
  });